import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SelectList from "../../../_common/SelectList";
import _ from "lodash";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import laborCrewActions from "../../../../_actions/laborCrewActions";

class EditLaborCrewModal extends Component {
  state = {
    formData: {
      laborCrewId: 0,
      projectContractorContractorId: null,
      projectId: null,
      crewName: "",
      isBridgeCrew: false,
      selectedLabors: [],
      deletedLabors: [],
      laborIds: [],
    },
    laborToReassign: null,
    laborList: [],
    formErrors: {
      crewName: null,
    },
  };

  columns = [
    { path: "fullName", colSize: "col-6" },
    { path: "trade", colSize: "col-5" },
  ];

  componentDidMount() {
    let formData = { ...this.state.formData };
    const { projLaborList, laborCrew, isNew } = this.props;

    // Check prevProps against this.props to determine the need for pre-populating
    if (laborCrew && !isNew) {
      // Map incoming prop data to formData
      formData.laborCrewId = laborCrew.laborCrewId;
      formData.projectId = laborCrew.projectId;
      formData.crewName = laborCrew.crewName;
      formData.isBridgeCrew = laborCrew.isBridgeCrew;
      formData.laborIds = laborCrew.laborIds ? [...laborCrew.laborIds] : [];

      laborCrew.laborIds &&
        laborCrew.laborIds.forEach((labId) => {
          const labor = (projLaborList || []).find((l) => l.laborId === labId);
          if (labor) formData.selectedLabors.push(labor);
        });
    }
    this.setState({ formData, laborList: projLaborList });
  }

  handleChange_lcForm = (e) => {
    const formData = { ...this.state.formData };
    formData[e.target.name] = e.target.value;
    this.setState({ formData });
  };

  handleChange_lcForm_select = (fieldName, fieldOptionName) => (selectedOption) => {
    const formData = { ...this.state.formData };
    formData[fieldName] = selectedOption.value;
    formData[fieldOptionName] = selectedOption;
    this.setState({ formData });
  };

  populateLaborList = () => this.setState({ laborList: this.props.projLaborList });

  handleChange_lcForm_check = (e) =>
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.checked },
    });

  handleBlur_lcForm = (e) => this.validateForm(e.target.name);

  addLaborToCrew = (laborId) => {
    const { projLaborList } = this.props;
    let formData = { ...this.state.formData };
    const recoverableLabor = formData.deletedLabors.find((l) => l.laborId === laborId);
    if (recoverableLabor) {
      formData.laborIds.push(recoverableLabor.laborId);
      formData.selectedLabors.push(recoverableLabor);
      formData.deletedLabors = formData.deletedLabors.filter(
        (l) => l.laborId !== recoverableLabor.laborId
      );
    } else {
      const labor = (projLaborList || []).find((l) => l.laborId === laborId);
      if (labor) {
        formData.laborIds.push(laborId);
        formData.selectedLabors.push(labor);
      }
    }
    this.setState({
      formData: {
        ...formData,
        selectedLabors: _.orderBy(formData.selectedLabors, "fullName", "asc"),
      },
    });
  };

  removeLaborFromCrew = (laborId) => {
    let formData = { ...this.state.formData };
    const laborToDelete = formData.selectedLabors.find((l) => l.laborId === laborId);
    formData.laborIds = formData.laborIds.filter((l) => l !== laborId);
    formData.selectedLabors = formData.selectedLabors.filter(
      (l) => l.laborId !== laborId
    );
    formData.deletedLabors.push(laborToDelete);
    this.setState({ formData });
  };

  validateForm = (fieldName) => {
    const { formData } = this.state;
    const formErrors = { ...this.state.formErrors };
    switch (fieldName) {
      case "crewName":
        formErrors.crewName = formData.crewName === "" ? "Required" : null;
        break;
      default:
        break;
    }
    this.setState({ formErrors });
  };

  formIsIncomplete = () => {
    const { formData } = this.state;
    const { crewName } = this.state.formErrors;
    if (crewName || formData.crewName === "") return true;
    else return false;
  };

  handleSubmit_lcForm = async (e) => {
    e.preventDefault();
    const { dispatch, isNew, projectId, user } = this.props;
    let formData = { ...this.state.formData };
    formData = {
      ...formData,
      projectId,
      createdByUserId: user.userId,
    };
    if (isNew) await dispatch(laborCrewActions.add(formData));
    else await dispatch(laborCrewActions.update(formData));
    this.toggleModal();
  };

  resetState = () =>
    this.setState({
      formData: {
        crewName: "",
        isBridgeCrew: false,
        selectedLabors: [],
        laborIds: [],
      },
      laborList: [],
      formErrors: {
        crewName: null,
      },
    });

  toggleModal = () => {
    this.props.toggleEditLcModal();
  };

  render() {
    const { formData, formErrors, laborList } = this.state;
    const { showEditLcModal, isNew } = this.props;
    const closeBtn = (
      <button className="close" onClick={this.toggleModal}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );
    return (
      <React.Fragment>
        <Modal
          isOpen={showEditLcModal}
          toggle={this.toggleModal}
          className={this.props.className}
          size={"xl"}
          fade={false}
        >
          <ModalHeader
            toggle={this.toggleModal}
            className="bg-info text-white"
            close={closeBtn}
          >
            {isNew ? (
              <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
            ) : (
              <FontAwesomeIcon icon="edit" className="fa-fw mr-2" />
            )}
            {isNew ? "Add New Labor Crew" : "Edit Labor Crew"}
          </ModalHeader>
          <ModalBody>
            <form
              id="addContractorForm"
              onSubmit={this.handleSubmit_lcForm}
              autoComplete="off"
            >
              <div className="card mb-2">
                <div className="card-body">
                  <div className="form-row form-group mb-2">
                    <label htmlFor="name" className="col-sm-2 col-form-label my-auto">
                      <b>Crew Name:</b>*
                    </label>
                    <div className="col-sm-5">
                      <input
                        type="text"
                        name="crewName"
                        id="crewName"
                        className="form-control"
                        value={formData.crewName}
                        onChange={this.handleChange_lcForm}
                        onBlur={this.handleBlur_lcForm}
                      />
                      {formErrors.crewName && (
                        <span className="error-small">
                          <small>{formErrors.crewName}</small>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-row form-group mb-0">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        name="isBridgeCrew"
                        id="isBridgeCrew"
                        checked={formData.isBridgeCrew}
                        onChange={this.handleChange_lcForm_check}
                      />
                      <label className="custom-control-label" htmlFor="isBridgeCrew">
                        This is a Structures Crew
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex flex-row">
                <div className="d-flex flex-column w-50 pr-1">
                  <div className="card flex-grow-1">
                    <div className="card-body">
                      <h5 className="text-muted">Project Labor List</h5>
                      {laborList.length > 0 ? (
                        <SelectList
                          className="border border-top-0 lg-laborList"
                          data={laborList}
                          selectedItems={formData.selectedLabors}
                          deletedItems={formData.deletedLabors}
                          columns={this.columns}
                          idPropName={"laborId"}
                          onSelect={this.addLaborToCrew}
                          onDeselect={this.removeLaborFromCrew}
                          showSearch={true}
                        />
                      ) : (
                        <ul className="list-group list-group-flush">
                          <li className="list-group-item pl-1 py-1">
                            No contractor selected
                          </li>
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-column w-50 pl-1">
                  <div className="card flex-grow-1">
                    <div className="card-body">
                      <h5 className="text-muted">Selected Crew</h5>
                      <ul className="list-group list-group-flush">
                        {formData.selectedLabors.length > 0 ? (
                          formData.selectedLabors.map((l) => (
                            <li
                              key={`laborCrewLaborKey_${l.laborId}`}
                              className="list-group-item py-1 pl-1"
                            >
                              <div className="form-row">
                                <div className="col-sm-7">{l.fullName}</div>
                                <div className="col-sm-5">{l.trade}</div>
                              </div>
                            </li>
                          ))
                        ) : (
                          <li className="list-group-item py-1 pl-1">None selected</li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </ModalBody>
          <ModalFooter className="bg-lightgray">
            <input
              type="submit"
              name="submitAddNewContractor"
              id="submitAddNewContractor"
              form=""
              className="btn btn-primary"
              value="Save"
              onClick={this.handleSubmit_lcForm}
              disabled={this.formIsIncomplete()}
            />{" "}
            <button
              type="button"
              className="btn btn-secondary"
              name="cancelAddNewContractor"
              id="cancelAddNewContractor"
              onClick={this.toggleModal}
            >
              Cancel
            </button>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.authentication.user,
  projLaborList: state.labors.projLaborLists[ownProps.projectId] || null,
});

export default connect(mapStateToProps)(EditLaborCrewModal);
